module.exports = __webpack_public_path__ + "static/media/logo_back.e368ca49.svg";